import { Tooltip } from "@mui/material";
import "./ListTable.scss";

interface ListItemProps {
  label: string;
  maxWidth?: string;
  minWidth?: string;
  truncate?: boolean;
  value: string;
}

const ListItem = ({
  label,
  maxWidth,
  minWidth,
  truncate = false,
  value,
}: ListItemProps) => {
  return (
    <div className="listItemCol" style={{ minWidth, maxWidth }}>
      <Tooltip title={label} arrow>
        <span className={truncate ? "truncate listItemLabel" : "listItemLabel"}>
          {label}
        </span>
      </Tooltip>

      <Tooltip title={value} arrow>
        <span className={truncate ? "truncate listItemCol" : "listItemCol"}>
          {value}
        </span>
      </Tooltip>
    </div>
  );
};

export default ListItem;
